module.exports = __webpack_public_path__ + "img/wazdan.cfcdc846.svg";